import { DocumentationGroupBehavior, ElementGroup, } from "@supernova-studio/model";
import { DTODocumentationItemConfigurationV1 } from "./item-configuration-v1";
import { z } from "zod";
//
// Read
//
/**
 * Structure DTO is element properties minus element data (in other words data required
 * to display the element in the left panel)
 */
export const DTODocumentationGroupStructureV1 = ElementGroup.omit({
    sortOrder: true,
    parentPersistentId: true,
    brandPersistentId: true,
    meta: true,
    childType: true,
    data: true,
    shortPersistentId: true,
}).extend({
    title: z.string(),
    isRoot: z.boolean(),
    childrenIds: z.array(z.string()),
    groupBehavior: DocumentationGroupBehavior,
    shortPersistentId: z.string(),
    type: z.literal("Group"),
});
export const DTODocumentationGroupV1 = DTODocumentationGroupStructureV1.extend({
    configuration: DTODocumentationItemConfigurationV1,
});
